import { ApiClient } from './client';
import { calculateStreak } from '@/services/gamification/StreakService';
import { usersAPI } from './users.api';
import { rankingsAPI } from './rankings.api';
import type {
  StreakData,
  ActivityDay,
  XPProgress,
  RankingEntry,
  UserAchievement,
} from '@/types/gamification.types';

const XP_PER_LEVEL = 500;

export async function getUserStreak(_userId: string): Promise<StreakData> {
  const activities = await usersAPI.getActivities();
  return calculateStreak(activities);
}

export async function getUserActivities(_userId: string): Promise<ActivityDay[]> {
  return usersAPI.getActivities();
}

export async function getUserXPProgress(_userId: string): Promise<XPProgress> {
  const stats = await usersAPI.getStats();
  const totalXP = stats.totalXP;
  const currentLevel = Math.floor(totalXP / XP_PER_LEVEL) + 1;
  const xpInCurrentLevel = totalXP % XP_PER_LEVEL;
  return {
    currentLevel,
    totalXP,
    currentLevelXP: xpInCurrentLevel,
    nextLevelXP: XP_PER_LEVEL - xpInCurrentLevel,
    progressPercentage: Math.round((xpInCurrentLevel / XP_PER_LEVEL) * 100),
  };
}

// `limit` opcional: sin él, todos los alumnos de la empresa (pestaña Empresa).
export async function getCompanyRankings(companyId: string, limit?: number): Promise<RankingEntry[]> {
  return rankingsAPI.getCompanyRanking(companyId, limit);
}

export async function getUserRank(userId: string): Promise<RankingEntry | null> {
  const rankings = await rankingsAPI.getGlobalRanking(50);
  return rankings.find((r) => r.userId === userId) ?? null;
}

// `limit` opcional: sin él, se devuelven TODOS los alumnos (pestaña Global).
export async function getGlobalRankings(limit?: number): Promise<RankingEntry[]> {
  return rankingsAPI.getGlobalRanking(limit);
}

export async function getUserAchievements(_userId: string): Promise<UserAchievement[]> {
  return ApiClient.get<UserAchievement[]>('/users/me/achievements');
}

export async function unlockAchievement(_userId: string, achievementId: string): Promise<UserAchievement> {
  return ApiClient.post<UserAchievement>(`/users/me/achievements/${achievementId}/unlock`);
}
